import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CollapsibleTabs from "components/CollapsibleTabs/CollapsibleTabs";
import { AdminViewTabs, SessionItems } from "constants/AdminViewConstants";
import UserAdminSummary from "components/UserAdminSummary/UserAdminSummary";
import { changeAdminViewSection } from "actions/adminViewActions";
import CannedMessagesSummary from "components/UserAdminSummary/CannedMessagesSummary";
import BrochuresSummary from "components/UserAdminSummary/BrochuresSummary";
import "./UserAdminLeftSection.scss";

function UserAdminLeftSection(props) {
  const { adminView } = props;
  const highlightedClass = (tab) =>
    adminView.section === tab ? "highlighted" : "";
  const tabs = [
    {
      value: AdminViewTabs.USER_SUMMARY,
      content: <UserAdminSummary />,
      label: "User Summary",
      active: adminView.section === AdminViewTabs.USER_SUMMARY,
      className: highlightedClass(AdminViewTabs.USER_SUMMARY),
    },
    {
      value: AdminViewTabs.CANNED_MESSAGES,
      content: <CannedMessagesSummary />,
      label: "Canned Messages",
      active: adminView.section === AdminViewTabs.CANNED_MESSAGES,
      className: highlightedClass(AdminViewTabs.CANNED_MESSAGES),
    },
    {
      value: AdminViewTabs.BROCHURES,
      content: <BrochuresSummary />,
      label: "Brochures",
      active: adminView.section === AdminViewTabs.BROCHURES,
      className: highlightedClass(AdminViewTabs.BROCHURES),
    },
  ];

  const onTabChange = useCallback(
    (tab) => {
      props.changeAdminViewSection(tab);
      persistInSession(tab);
    },
    [props]
  );

  const persistInSession = (tab) => {
    sessionStorage.setItem(SessionItems.ADMIN_ACTIVE_TAB, tab);
  };

  const getTabFromSession = () => {
    return sessionStorage.getItem(SessionItems.ADMIN_ACTIVE_TAB);
  };

  useEffect(() => {
    const tabInSession = getTabFromSession();
    if (tabInSession) {
      onTabChange(tabInSession);
    }
  }, [onTabChange]);

  return (
    <div className="user-admin-left-section">
      <CollapsibleTabs
        className="user-admin-left-collapsible-tabs"
        tabs={tabs}
        onChange={onTabChange}
        noScroll
        useDefaultTheme
      />
    </div>
  );
}

UserAdminLeftSection.propTypes = {
  adminView: PropTypes.object.isRequired,
  changeAdminViewSection: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  adminView: state.adminView,
});

const mapDispatchToProps = {
  changeAdminViewSection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAdminLeftSection);
